import React from 'react';

import {StandardFeature} from 'auth/capabilities/CapabilityConstants';
import {getFeatureStatus} from 'auth/feature-enablement/FeatureStatus';
import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {Request} from 'requests/RequestConstants';
import {ListableItem} from 'search/SearchConstants';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import fuzzydate from 'util/fuzzydate';

import SidepanelItem from './SidepanelItem';

interface Props {
  isActive: boolean;
  isCompact: boolean;
  request: Request;
  openResult: (request: ListableItem) => void;
  isChild: boolean;
}

class RequestSidepanelItem extends React.Component<Props> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleOpen = () => {
    this.props.openResult(this.props.request);
  };

  render(): JSX.Element {
    const {isActive, isCompact, request} = this.props;
    const date = fuzzydate(request.createdAt, {compact: isCompact, showTime: false});
    const subtitle = `${isCompact ? '' : 'Created '}${date}`;
    const featureStatus = getFeatureStatus({
      feature: StandardFeature.OPEN,
      item: request,
    });
    return (
      <SidepanelItem
        active={isActive}
        className="sidepanelItem--noIcon"
        faded={!featureStatus.enabled}
        icon={<BenchlingIcon icon={ModelTypeConstants.REQUEST} />}
        isCompact={isCompact}
        onClick={this._handleOpen}
        parties={[
          BenchlingConfig.REQUESTS_ENABLE_REQUESTOR
            ? this.props.request.requestor
            : this.props.request.creator,
        ]}
        subTitle={subtitle}
        title={{text: request.name}}
        tooltipText={featureStatus.enabled ? '' : featureStatus.userMessage}
        isExpandable={false}
        isChild={this.props.isChild}
      />
    );
  }
}

export default RequestSidepanelItem;
